import { io } from "socket.io-client";

const SOCKET_LOG_PREFIX = "[AdminOrderSocket]";

const getSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) {
    return process.env.REACT_APP_SOCKET_URL.replace(/\/$/, "");
  }

  const apiUrl = process.env.REACT_APP_API || "";
  return apiUrl.replace(/\/v1\/?$/, "").replace(/\/$/, "");
};

export const createAdminOrderSocket = () => {
  const socketUrl = getSocketUrl();
  const token = localStorage.getItem("sessionToken");

  console.log(`${SOCKET_LOG_PREFIX} Connecting to`, socketUrl);

  const socket = io(socketUrl, {
    transports: ["websocket", "polling"],
    autoConnect: true,
    auth: token ? { token } : undefined,
    extraHeaders: token ? { Authorization: `Bearer ${token}` } : undefined,
  });

  socket.on("connect", () => {
    console.log(`${SOCKET_LOG_PREFIX} Connected`, {
      id: socket.id,
      url: socketUrl,
    });
  });

  socket.on("disconnect", (reason) => {
    console.log(`${SOCKET_LOG_PREFIX} Disconnected`, { reason });
  });

  socket.on("connect_error", (error) => {
    console.error(`${SOCKET_LOG_PREFIX} Connection error`, error?.message || error);
  });

  socket.on("reconnect", (attempt) => {
    console.log(`${SOCKET_LOG_PREFIX} Reconnected`, { attempt });
  });

  return socket;
};

export const subscribeAdminOrder = (socket, orderId) => {
  if (!socket || !orderId) return;

  const payload = { order_id: orderId };
  console.log(`${SOCKET_LOG_PREFIX} Event trigger → subscribe_admin_order`, payload);
  socket.emit("subscribe_admin_order", payload);
};

export const unsubscribeAdminOrder = (socket, orderId) => {
  if (!socket || !orderId) return;

  const payload = { order_id: orderId };
  console.log(`${SOCKET_LOG_PREFIX} Event trigger → unsubscribe_admin_order`, payload);
  socket.emit("unsubscribe_admin_order", payload);
};

export const ADMIN_ORDER_STATUS_CHANGED = "admin_order_status_changed";
